"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var moves = {
  RIGHT: 0,
  DOWNRIGHT: 1,
  DOWN: 2,
  DOWNLEFT: 3,
  LEFT: 4,
  UPLEFT: 5,
  UP: 6,
  UPRIGHT: 7
};

exports.default = moves;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-touch/lib/gestureMoves.js
// module id = ./node_modules/react-touch/lib/gestureMoves.js
// module chunks = main